module.exports = "<app-header></app-header>\n<router-outlet></router-outlet>\n<app-footer></app-footer>\n<ng2-loading-bar></ng2-loading-bar>\n\n"


//////////////////
// WEBPACK FOOTER
// /home3/usalinks/public_html/ally-book-source/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main